import React from 'react'
import { generatePath, useNavigate, useParams } from 'react-router-dom'
import { ALTER_ERROR, useSnackbar } from 'storfox-snackbar'
import { prop, propOr } from 'ramda'

import { DashboardLayout } from '~/components/Layouts'
import * as ROUTES from '~/constants/routes'
import * as NAV from '~/constants/nav-titles'
import ErrorLink from '~/components/ErrorLink'
import { INTEGRATION_TABS } from '~/constants/tabs'
import useMessages from '~/hooks/useMessages'

import { useIntegrationHistory, useTraxDetail, useTraxRemove, useTraxUpdate } from '../../hooks'
import TraxIntegrationUpdateForm from '../../components/Trax/TraxIntegrationUpdateForm'

function TraxIntegrationUpdateContainer () {
  const { guid, tab } = useParams()

  const snackbar = useSnackbar()
  const navigate = useNavigate()
  const messages = useMessages()
  const traxDetail = useTraxDetail(guid)
  const traxUpdate = useTraxUpdate(guid)
  const traxRemove = useTraxRemove()

  const historyAutoSend = Boolean(guid && tab === INTEGRATION_TABS.LOGS)
  const integrationHistory = useIntegrationHistory(guid, historyAutoSend)

  const title = prop('name', traxDetail.detail)
  const type = propOr('', 'type', traxDetail.detail)

  const detailPath = generatePath(ROUTES.INTEGRATION_UPDATE_PATH, { guid, type, tab: INTEGRATION_TABS.GENERAL })

  const handleSubmit = formValues =>
    traxUpdate.update(formValues)
      .then(() => {
        snackbar({ message: messages.UPDATE_SUCCESS })
        navigate(detailPath)
      })
      .catch(error => {
        const message = <ErrorLink error={error} />
        snackbar({ message, type: ALTER_ERROR })
      })

  const isLoading = (
    traxDetail.isLoading ||
    traxUpdate.isLoading
  )

  const handleRemove = () =>
    traxRemove.delete({ guids: [guid] })
      .then(() => navigate(ROUTES.INTEGRATION_LIST_PATH, { replace: true }))

  const breadcrumbs = { title }

  return (
    <DashboardLayout
      isLoading={traxDetail.isLoading}
      activeNav={NAV.INTEGRATION}
      breadcrumbs={breadcrumbs}
    >
      <TraxIntegrationUpdateForm
        isLoading={isLoading}
        pageTitle={title}
        pageTitleLoading={traxDetail.isLoading}
        onSubmit={handleSubmit}
        onRemove={handleRemove}
        initialValues={traxDetail.detail}
        history={integrationHistory}
      />
    </DashboardLayout>
  )
}

export default TraxIntegrationUpdateContainer
